<template>
    <div class="task-form-component">
        <div class="task-body">
            <b-form data-vv-scope="task-form">
                <b-form-group
                    label="Judul Penugasan"
                    label-for="title"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="title-task"
                        name="title_task"
                        data-vv-as="Judul penugasan"
                        v-model="task_form.name"
                        type="text"
                        placeholder="Judul Penugasan"
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('task-form.title_task') }">{{ errors.first('task-form.title_task') }}</span>
                </b-form-group>
                <b-form-group
                    label="Bentuk Pengerjaan"
                    label-for="type"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-select
                        v-model="task_form.type"
                        name="type"
                        data-vv-as="Bentuk pengerjaan"
                        v-validate="'required'"
                        :options="taskType"
                        value-field="id"
                        placeholder="Bentuk Pengerjaan"
                        text-field="name"
                    >
                        <b-form-select-option :value="null" disabled>Please select an option</b-form-select-option>
                    </b-form-select>
                    <span :class="{ 'error-validation': errors.first('task-form.type') }">{{ errors.first('task-form.type') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="task_form.type == 'ujian'"
                    label="Durasi"
                    label-for="duration"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input
                        id="duration"
                        name="duration"
                        data-vv-as="Durasi"
                        v-model="task_form.duration"
                        type="text"
                        @keypress="isNumber($event)"
                        placeholder="Lama Pengerjaan dalam satuan menit."
                        v-validate="'required'"
                        autocomplete="off"
                    ></b-form-input>
                    <span :class="{ 'error-validation': errors.first('task-form.duration') }">{{ errors.first('task-form.duration') }}</span>
                </b-form-group>
                <!-- <b-form-group
                    label="Awal Pengerjaan"
                    label-for="start_date"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="start-date"
                        v-model="task_form.start_date"
                        name="start_date"
                        data-vv-as="Tanggal awal pengerjaan"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('task-form.start_date') }">{{ errors.first('task-form.start_date') }}</span>
                </b-form-group>
                <b-form-group
                    label="Akhir Pengerjaan"
                    label-for="end_date"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-datepicker
                        id="end-date"
                        v-model="task_form.end_date"
                        name="end_date"
                        data-vv-as="Tanggal akhir pengerjaan"
                        v-validate="'required'"
                        class="mb-2"
                    ></b-form-datepicker>
                    <span :class="{ 'error-validation': errors.first('task-form.end_date') }">{{ errors.first('task-form.end_date') }}</span>
                </b-form-group> -->
                <b-form-group
                    label="Sumber Soal"
                    label-for="Sumber soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                    >
                    <b-form-radio-group
                        id="tes"
                        name="tes"
                        v-model="task_form.is_file"
                        :options="option_links"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.is_file') }">{{ errors.first('petunjuk-form.is_file') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="task_form.is_file==1"
                    label="Pilih Sumber"
                    label-for="Pilih Sumber"
                    label-cols-sm="3"
                    label-align-sm="left"
                    >
                    <b-form-radio-group
                        id="fileType"
                        name="fileType"
                        v-model="task_form.file_type"
                        :options="option_types"
                        class="mb-3"
                        value-field="item"
                        text-field="name"
                        v-validate="'required'"
                    ></b-form-radio-group>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.file_type') }">{{ errors.first('petunjuk-form.file_type') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="task_form.is_file==1"
                    label="Input Link"
                    label-for="Input Link"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <b-form-input v-model="task_form.file_path" v-validate="'required'"></b-form-input>
                    <span :class="{ 'error-validation': errors.first('petunjuk-form.file_path') }">{{ errors.first('petunjuk-form.file_path') }}</span>
                </b-form-group>
                <b-form-group
                    v-if="task_form.is_file==0"
                    label="Soal"
                    label-for="soal"
                    label-cols-sm="3"
                    label-align-sm="left"
                >
                    <wysiwyg
                        id="soal"
                        name="description"
                        data-vv-as="Soal"
                        v-model="task_form.description"
                        type="text"
                        v-validate="'required'"
                        autocomplete="off"
                    />
                    <span :class="{ 'error-validation': errors.first('task-form.description') }">{{ errors.first('task-form.description') }}</span>
                </b-form-group>
            </b-form>
        </div>
        <hr>
        <div class="new-class-footer d-flex justify-content-end">
            <square-loader :loading="showLoader" :color="'#ca062a'" :size="'30px'"></square-loader>
            <b-button v-if="!showLoader" variant="outline-danger" size="md" style="width: 25%;" @click="hideTaskFormModal">BATAL</b-button>
            <b-button v-if="!showLoader" variant="primary" size="md" style="width: 25%;" @click.prevent="saveTask">SIMPAN</b-button>
        </div>
    </div>
</template>
<script>
    import SquareLoader from 'vue-spinner/src/SquareLoader.vue'
    import { EventBus } from '@/eventBus.js'
    export default {
        props: {
            modulId: {
                type: String,
                default: null
            },
            taskId: {
                type: String,
                default: null
            },
            taskType: {
                type: Array,
                default: null
            },
            taskDetail: {
                type: Object,
                default() {
                    return {}
                }
            }
        },
        components: {
            SquareLoader
        },
        data() {
            return {
                showLoader: false,
                task_form: {
                    learning_activity_id: this.modulId,
                    name: this.taskId ? this.taskDetail.name : null,
                    description: this.taskId ? this.taskDetail.description : null,
                    type: this.taskId ? this.taskDetail.type : null,
                    duration: this.taskId ? this.taskDetail.duration : null,
                    // start_date: this.taskId ? this.taskDetail.start_date : null,
                    // end_date: this.taskId ? this.taskDetail.end_date : null,
                    is_file: this.taskId ? this.taskDetail.is_file : null,
                    file_type: this.taskId ? this.taskDetail.file_type : null,
                    file_path: this.taskId ? this.taskDetail.file_path : null
                },
                option_links: [
                    { item: '1', name: 'Link' },
                    { item: '0', name: 'Text' },
                ],
                option_types: [
                    { item: 'pdf', name: 'Google Drive' },
                    { item: 'video', name: 'Youtube' },
                ]
            };
        },
        methods: {
            resetTaskForm() {
                this.task_form.learning_activity_id = this.modulId
                this.task_form.name = this.taskId ? this.taskDetail.name : null
                this.task_form.description = this.taskId ? this.taskDetail.description : null
                this.task_form.type = this.taskId ? this.taskDetail.type : null
                this.task_form.duration = this.taskId ? this.taskDetail.duration : null
                // this.task_form.start_date = this.taskId ? this.taskDetail.start_date : null
                // this.task_form.end_date = this.taskId ? this.taskDetail.end_date : null
                this.$validator.reset()
            },
            hideTaskFormModal() {
                EventBus.$emit('hideTaskFormModal', true)
                this.resetTaskForm()
            },
            async saveTask() {
                let scope = 'task-form'
                this.$validator.validateAll(scope).then(valid => {
                    if (valid) {
                        if (this.taskId) {
                            this.task_form.id = this.taskId
                            this.updateTask(scope)
                        } else {
                            this.addTask(scope)
                        }
                    }
                });
            },
            async addTask(scope) {
                this.showLoader = true
                if(this.task_form.is_file==1){
                    this.task_form.description = '-'
                }else{
                    this.task_form.file_type = 'text'
                    this.task_form.file_path = '-'
                }
                let form = this.task_form
                this.$store.dispatch('addTask', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getTaskOverview', { modulId })
                        this.hideTaskFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            },
            async updateTask(scope) {
                this.showLoader = true
                if(this.task_form.is_file==1){
                    this.task_form.description = '-'
                }else{
                    this.task_form.file_type = 'text'
                    this.task_form.file_path = '-'
                }
                let form = this.task_form
                this.$store.dispatch('updateTask', form)
                    .then((res) => {
                        this.showLoader = false
                        let modulId = this.modulId
                        this.$store.dispatch('getTaskOverview', { modulId })
                        this.hideTaskFormModal()
                        this.$swal.fire('Success', res.message, 'success')
                    })
                    .catch((err)=> {
                        let error = err.response
                        this.showLoader = false
                        if (error.status == 400) {
                            this.errorValidate(error.data, scope)
                        } else {
                            this.$swal.fire('Failed', error.data.message, 'error')
                        }
                    })
            }
        },
        created() {
			EventBus.$on('resetTaskForm', (val) => {
				if (val) {
					this.resetTaskForm()
				}
			})
        }
    }
</script>